import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import NavMenu from './NavMenu';
import Footer from './Footer';

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        <Container fluid className="header">
            <Row className="announcement-bar">
                <Col>Call Premier Pressure Washing and Window Cleaning for a FREE estimate! <a href="tel:16026896045">602.689.6045</a></Col>
            </Row>
        </Container>
        <NavMenu/>
        <div className="root">
            {props.children}
        </div>
        <Footer />
    </React.Fragment>
);
